import loginService from 'app/services/loginService';
import * as UserActions from './user.actions';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export function submitLogin({ email, password }) {
	return dispatch =>
		loginService
			.signInWithEmailAndPassword(email, password)
			.then(user => {
				// user.userType= "Admin"
				// user.authToken= "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlclR5cGUiOiJBZG1pbiIsImVtYWlsIjoiYWRtaW5AZG9tdG0uY29tIiwiaWF0IjoxNjQ2MTIwODEyLCJleHAiOjE2NDYzMDA4MTJ9.Kp7nct7mFUWkNeVbCI_JdEaR3FI1VvW1lSLs7ZJRyx8"
				// user.email= "admin@domtm.com"
				// user.firstName= "Admin"
				// user.lastName= "one"
				user.userType= "Admin"
				// user.user_id= "4658c7f863c1a002eaa331b16e7f5ff2"
				localStorage.setItem('userData', JSON.stringify(user))

				dispatch(UserActions.setUserData(user));
				return dispatch({
					type: LOGIN_SUCCESS	
				});
			})
			.catch(error => {
				return dispatch({
					type: LOGIN_ERROR,
					payload: error
				});
			});
}


